/* Finance tour — 7 steps. Money + GST surface. */
export default {
  role: "FINANCE",
  steps: [
    {
      id: "fin-welcome",
      route: "/",
      selector: '[data-tour-id="topbar-profile"]',
      titleKey: "tour.fin.welcome.title", titleFallback: "Welcome, {name}",
      bodyKey: "tour.fin.welcome.body", bodyFallback: "Tour focuses on invoicing, payments, and AR ageing. ~3 minutes.",
      side: "bottom",
    },
    {
      id: "fin-invoices",
      route: "/sales/invoices",
      selector: '[data-tour-id="invoices-list"]',
      titleKey: "tour.fin.invoices.title", titleFallback: "Invoices",
      bodyKey: "tour.fin.invoices.body", bodyFallback: "GST-compliant invoicing. e-invoice IRP scaffold ready for when you provide IRN creds.",
      side: "top",
    },
    {
      id: "fin-new-invoice",
      route: "/sales/invoices",
      selector: '[data-tour-id="invoices-list"]',
      titleKey: "tour.fin.newInv.title", titleFallback: "Convert quote → invoice",
      bodyKey: "tour.fin.newInv.body", bodyFallback: "Pick an accepted quote → one click → tax-correct invoice. Edit line items if needed.",
      side: "top",
    },
    {
      id: "fin-payments",
      route: "/sales/payments",
      selector: '[data-tour-id="payments-page"]',
      titleKey: "tour.fin.payments.title", titleFallback: "Payments + collections",
      bodyKey: "tour.fin.payments.body", bodyFallback: "Money in, money out. One-click match.",
      side: "top",
      optional: true,
    },
    {
      id: "fin-ageing",
      route: "/sales/reports",
      selector: '[data-tour-id="reports-page"]',
      titleKey: "tour.fin.ageing.title", titleFallback: "AR ageing",
      bodyKey: "tour.fin.ageing.body", bodyFallback: "30/60/90/120+ buckets. Drill to customer → invoice → reminder log.",
      side: "top",
      optional: true,
    },
    {
      id: "fin-gst-fab",
      route: "/sales/invoices",
      selector: '[data-tour-id="gst-fab"]',
      titleKey: "tour.fin.gst.title", titleFallback: "GST Advisor",
      bodyKey: "tour.fin.gst.body", bodyFallback: "Ambiguous HSN? IGST vs CGST/SGST question? Click and ask — Claude-backed.",
      side: "left",
      optional: true,
    },
    {
      id: "fin-replay",
      route: "/",
      selector: '[data-tour-id="tour-button"]',
      titleKey: "tour.fin.replay.title", titleFallback: "Replay anytime",
      bodyKey: "tour.fin.replay.body", bodyFallback: "Header button. Hit it whenever.",
      side: "bottom",
    },
  ],
};
